const DEFAULT_UNITS = {
  massKg: "kg",
  heightCm: "cm",
  payloadValue: "kg",
  runtimeMin: "minutes",
  runtimeMax: "minutes",
  durationMinutes: "minutes",
  trainingDataHours: "hours",
  averageHandlingTimeSeconds: "seconds",
  reportedSuccessRate: "%",
};

const QUALIFIERS = {
  "more-than": "More than ",
  "up-to": "Up to ",
  "at-least": "At least ",
  approximately: "About ",
  scheduled: "Scheduled ",
};

export function formatChartValue(row, key) {
  const value = row[key];
  if (value === null || value === undefined || value === "") return "Not recorded";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value !== "number") return String(value);
  if (/^(releaseYear|foundedYear|year)$/.test(key)) return String(value);
  const unit = row[`${key}Unit`] || DEFAULT_UNITS[key]
    || (key === "documentedVolume" ? row.unit : "")
    || (["amount", "valuation", "price"].includes(key) ? row.currency : "") || "";
  const qualifier = row[`${key}Qualifier`] || (key === "durationMinutes" ? row.durationQualifier : "");
  const prefix = qualifier ? QUALIFIERS[qualifier] || `${qualifier} ` : "";
  return `${prefix}${value.toLocaleString("en-US")}${unit ? ` ${unit}` : ""}`;
}

export function csvEscape(value) {
  if (value === null || value === undefined) return "";
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function buildChartCsv(fields, entries) {
  const fieldKeys = new Set(fields.map((field) => field.key));
  const extraKeys = [...new Set(entries.flatMap((entry) => Object.keys(entry)))].filter((key) => !fieldKeys.has(key));
  const columns = [...fields, ...extraKeys.map((key) => ({ key, label: key.replace(/([A-Z])/g, " $1").replace(/^./, (letter) => letter.toUpperCase()) }))];
  const rows = [columns.map((field) => field.label), ...entries.map((entry) => columns.map((field) => entry[field.key]))];
  return rows.map((row) => row.map(csvEscape).join(",")).join("\r\n");
}
